export const csvHeader = [
  "COMPCODE",
  "Location CODE",
  "SSN",
  "EMPLOYER ID",
  "DRIVER ID",
  "State of Issuance",
  "ALTERNATE ID",
  "Fname",
  "Lname",
  "RegMode",
  "Employee Category",
  "OccupationCode",
  "DOB",
  "Hire DATE",
  "MANAGER",
  "Home Phone",
  "Work Phone",
  "STREET ADDRESS",
  "CITY",
  "STATE",
  "ZIP",
  "Supervisor 1",
  "Supervisor 2",
  "ReasonForInactivation",
]
